
const m = window.require("discourse/modifiers/swipe");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
